import "./index.es44.js";
import m from "./index.es45.js";
import "./index.es46.js";
import "./index.es47.js";
import "./index.es48.js";
import "./index.es49.js";
import i from "react";
import "./index.es50.js";
import "./index.es51.js";
const y = ({
  chart: t,
  fileName: o
}) => {
  const r = (a) => {
    if (a.preventDefault(), t) {
      const e = document.createElement("a");
      t.update("none"), e.href = t.toBase64Image(), e.download = o, e.click();
    }
  };
  return /* @__PURE__ */ i.createElement(m, { isSmall: !0, styleType: "primary", onClick: r }, "Last ned bilde");
};
export {
  y as default
};
//# sourceMappingURL=index.es83.js.map
